// Load near-viewport images early and fade only images that have not been decoded.
// Never hide a cached/painted image after waiting for fonts or ScrollTrigger.
export function initImages({ motion, scope }) {
  const document=scope.document;
  const window=scope.ownerDocument.defaultView;
  const matchMedia=window.matchMedia.bind(window);
  const pending = new Set();
  const observer = new scope.IntersectionObserver(
    (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) return;
        target.loading = "eager";
        observer.unobserve(target);
      });
    },
    { rootMargin: "1200px" },
  );
  document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    if (!img.closest("[hidden]")) observer.observe(img);
  });
  document.querySelectorAll("img").forEach((img) => {
    // Interactive previews own their loading/transition lifecycle.
    if (
      img.closest(".aw-results__floating,.aw-result__photo,.aw-result-gallery")
    )
      return;
    if (img.complete && img.naturalWidth) return;
    if (img.src.endsWith(".svg") || img.closest(".aw-partners__logos")) return;
    const isFirstScreen = img.fetchPriority === "high";
    if (!isFirstScreen && motion.enabled) {
      img.classList.add("aw-image-pending");
      pending.add(img);
    }
    const ready = async () => {
      if(!scope.alive) return;
      try {
        await img.decode();
      } catch {}
      if(!scope.alive) return;
      img.classList.remove("aw-image-pending");
      img.classList.add("aw-image-ready");
      pending.delete(img);
    };
    scope.on(img, "load", ready, { once: true });
    scope.on(img, "error", () => {
        img.classList.remove("aw-image-pending");
        pending.delete(img);
      }, { once: true });
    if (img.complete) ready();
  });
  scope.on(document, "aw:motionchange", () => {
    if (!motion.enabled)
      pending.forEach((img) => img.classList.remove("aw-image-pending"));
  });
  scope.onDispose(()=>{pending.forEach(img=>img.classList.remove("aw-image-pending"));});
}
